import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { IntegrationStatusResponse } from "../../../components/types";

export type SalesforceStatusServiceType = {
    syncSalesforce(): Promise<unknown>;
    getSalesforceStatus(): Promise<IntegrationStatusResponse>;
    disconnectSalesforce(): Promise<unknown>;
};

export const salesforceStatusService = (fetchService: IFetchService): SalesforceStatusServiceType => ({
    getSalesforceStatus: createCancelable((signal: AbortSignal): Promise<IntegrationStatusResponse> => {
        return fetchService.get(`/sales-api/salesforce/status`, undefined, {
            cancellation: signal,
        });
    }),
    disconnectSalesforce: createCancelable((signal: AbortSignal): Promise<unknown> => {
        return fetchService.get(`sales-api/sw-connector/salesforce/disconnect`, undefined, {
            cancellation: signal,
        });
    }),
    syncSalesforce: createCancelable((signal: AbortSignal): Promise<unknown> => {
        return fetchService.get(`sales-api/sw-connector/salesforce/sync`, undefined, {
            cancellation: signal,
        });
    }),
});
